import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const StreetIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <line x1="7" y1="21" x2="7" y2="4" />
    <path d="M7 6h10l-2 2.5 2 2.5H7" />
  </svg>
);

export default StreetIcon;
